import React, { useState } from "react";
import excel from "../../assets/excel.svg";
import cog from "../../assets/cog.svg";
import link from "../../assets/link.svg";
import task from "../../assets/task.svg";
import "./ServicePanel.css";

const services = [
  {
    icon: excel,
    title: "Audyty Excela",
    subtitle: "Sprawdzimy, gdzie tracisz czas i pieniądze",
    intro: "Zbadamy Twoje pliki, procesy i przepływy danych — wykryjemy błędy, ryzyka i szanse do automatyzacji.",
    sections: [
      {
        heading: "Co zawiera audyt?",
        items: [
          "Analiza struktury — przejrzymy organizację arkuszy, nazewnictwo komórek, formularze.",
          "Weryfikacja formuł — sprawdzimy poprawność obliczeń i logiki biznesowej.",
          "Identyfikacja błędów — szukamy zależności, duplikatów i anomalii w danych.",
          "Ocena wydajności — sprawdzamy, czy plik ładuje się szybko i nie zużywa zbyt dużo zasobów.",
          "Rekomendacje — dostarczamy konkretne działania do poprawy bezpieczeństwa i efektywności.",
        ],
      },
      {
        heading: "Dla kogo?",
        text: "Audyt Excela to idealne rozwiązanie dla firm, które:",
        items: [
          "Pracują na dużych plikach Excel z wieloma użytkownikami.",
          "Chcą zmniejszyć ryzyko błędów w danych finansowych lub operacyjnych.",
          "Szukają możliwości automatyzacji powtarzalnych zadań.",
          "Planują migrację na nowe systemy i potrzebują przeglądu stanu.",
        ],
      },
      {
        heading: "Rezultat",
        text: "Po audycie otrzymasz raport z rekomendacjami, priorytetem działań i szacunkiem czasu wdrażania. To punkt wyjścia do optymalizacji Twojego Excela.",
      },
    ],
  },
  {
    icon: cog,
    title: "Automatyzacja i makra",
    subtitle: "Mniej ręcznej pracy, mniej błędów",
    intro: "Zamieniamy powtarzalne ręczne czynności w zautomatyzowane procesy — oszczędzając czas i eliminując błędy.",
    sections: [
      {
        heading: "Co możemy zautomatyzować?",
        items: [
          "Import i czyszczenie danych — automatyczne wczytywanie z różnych źródeł, normalizacja i walidacja.",
          "Obliczenia i raportowanie — powtarzalne raporty generowane kliknięciem przycisku zamiast manualnie.",
          "Wysyłanie raportów — automatyczne rozsyłanie wyników do zespołu lub klientów.",
          "Synchronizacja danych — połączenie wielu arkuszy lub źródeł w jeden przepływ.",
          "Makra VBA — dedykowane makra do bardziej skomplikowanych operacji.",
        ],
      },
      {
        heading: "Korzyści",
        items: [
          "Oszczędzenie 10–20 godzin pracy zespołu miesięcznie.",
          "Zmniejszenie ryzyka błędu człowieka.",
          "Szybsze dostarczanie informacji dla decydentów.",
          "Możliwość skupienia się na analizie zamiast na operacyjnych zadaniach.",
        ],
      },
      {
        heading: "Jak przebiega projekt?",
        text: "Zapoznajemy się z Twoim przepływem pracy, definiujemy reguły automatyzacji, wdrażamy i testujemy rozwiązanie razem z Twoim zespołem.",
      },
    ],
  },
  {
    icon: link,
    title: "Narzędzia na miarę",
    subtitle: "Dedykowane systemy biznesowe z Excela",
    intro: "Budujemy dedykowane systemy biznesowe z Excela — od zamówień po logistykę, wszystko pod Twoje potrzeby.",
    sections: [
      {
        heading: "Jakie narzędzia budujemy?",
        items: [
          "Systemy zamówień i sprzedaży — śledzenie od oferty do faktury z automatyczną kalkulacją.",
          "Platformy HR i kadrowe — zarządzanie pracownikami, urlopy, wynagrodzenia, oceny.",
          "Logistyka i inwentaryzacja — śledzenie magazynu, rezerwacje, dostawy.",
          "Systemy finansowe — budżety, prognozowanie, raporty dla zarządu.",
          "Quality Assurance — nadzór nad procesami, audyty, certyfikacje.",
        ],
      },
      {
        heading: "Proces wdrażania",
        text: "Analizujemy Twój biznes, definiujemy funkcjonalności, budujemy rozwiązanie faza po fazie, szkolimy zespół i wspieramy w eksploatacji.",
      },
    ],
  },
  {
    icon: task,
    title: "Dashboardy i raporty",
    subtitle: "Dane, które widać na pierwszy rzut oka",
    intro: "Wizualizujemy dane w interaktywne pulpity — decydenci widzą na pierwszy rzut oka, co się dzieje w biznesie.",
    sections: [
      {
        heading: "Co budujemy?",
        items: [
          "Pulpity menedżerskie — przegląd KPI, sprzedaży, kosztów, rentowności.",
          "Raporty finansowe — automatyczne zestawienia dla księgowości i zarządu.",
          "Analitykę operacyjną — śledzenie procesów, bottlenecks, efektywności.",
          "Wizualizacje danych — wykresy, mapy ciepła, sparklines — wszystko co się da.",
        ],
      },
      {
        heading: "Korzyści",
        items: [
          "Decyzje podejmowane szybciej i ostrożniej.",
          "Zmniejszenie czasu na zbieranie i kompilowanie danych.",
          "Łatwy dostęp dla całego zespołu.",
          "Raporty zawsze aktualne — bez ręcznego aktualizowania.",
        ],
      },
    ],
  },
  {
    icon: excel,
    title: "Szkolenia z Excela",
    subtitle: "Praktyczne warsztaty dla zespołów",
    intro: "Praktyczne warsztaty dla zespołów — nauczamy umiejętności, które zaraz będziecie używać w pracy.",
    sections: [
      {
        heading: "Programy szkoleniowe",
        items: [
          "Excel dla początkujących — podstawy formuł, funkcji, formatowania i sortowania.",
          "Power Query i Power Pivot — transformacja danych i wielowymiarowe analizy.",
          "Zaawansowane formuły — macierze, warunkowe, szukanie — rozwiązania zamiast ręcznego obliczania.",
          "Makra i VBA — automatyzacja dla zaawansowanych użytkowników.",
          "Szkolenia dedykowane — dostosowujemy program do Waszych procesów i potrzeb.",
        ],
      },
      {
        heading: "Format",
        text: "Spotkania offline w Waszym biurze, warsztatowo — każdy siedzi przy laptopie i robi zadania razem. Bez nudzenia się.",
      },
      {
        heading: "Efekt",
        text: "Po szkoleniu zespół radzi sobie samodzielnie. Nie czekają na nas — radzą sobie sami.",
      },
    ],
  },
  {
    icon: cog,
    title: "Analiza danych",
    subtitle: "Wzorce, trendy i okazje do wzrostu",
    intro: "Głębokie analizy Twoich danych — szukamy wzorców, trendów i okazji do wzrostu biznesu.",
    sections: [
      {
        heading: "Co analizujemy?",
        items: [
          "Dane sprzedaży — które produkty się sprzedają, do kogo, kiedy — sezonowość, trendy, klucze do sukcesu.",
          "Dane finansowe — rentowność, przepływy, marże — gdzie zarabiasz, gdzie tracisz.",
          "Dane operacyjne — procesy, wydajność, bottlenecks — co trzeba poprawiać.",
          "Dane z CRM/ERP — relacje z klientami, stany magazynu — pełny obraz biznesu.",
        ],
      },
      {
        heading: "Rezultat analizy",
        items: [
          "Raport z wizualizacjami — co się dzieje w danych.",
          "Rekomendacje działań — konkretne kroki do wzrostu.",
          "Dashboardy do monitoringu — ciągłe śledzenie zmian.",
        ],
      },
    ],
  },
  {
    icon: link,
    title: "Aplikacje Web",
    subtitle: "Nowość — Twoje narzędzia Excel jako aplikacja webowa",
    badge: "Nowość",
    intro: "Excel to świetny punkt startowy, ale nie zawsze wystarcza — zwłaszcza gdy z narzędzia korzysta cały zespół albo klienci z zewnątrz. Przenosimy Twoje arkusze i procesy do aplikacji webowej: dostępnej z każdego urządzenia, bez wysyłania plików mailem i bez ryzyka nadpisania cudzej pracy.",
    sections: [
      {
        heading: "Co robimy?",
        items: [
          "Zamiana istniejącego narzędzia Excel (np. CRM, system zamówień) w aplikację webową.",
          "Panel z logowaniem i uprawnieniami dla różnych użytkowników.",
          "Baza danych zamiast pojedynczego pliku — praca wielu osób naraz, bez konfliktów wersji.",
          "Integracje z innymi systemami i automatyczne raporty.",
        ],
      },
      {
        heading: "Dla kogo?",
        text: "Dla firm, które wyrosły z jednego pliku Excel i potrzebują narzędzia, które da się bezpiecznie skalować wraz z zespołem.",
      },
    ],
  },
];

const ServicePanel = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const activeService = services[activeIndex];

  return (
    <div className="service-panel" id="service-panel-id">
      <div className="service-container">
        <p className="title">co możemy dla Ciebie zrobić</p>
        <p className="subtitle">Nasze usługi</p>
        <div className="service-split">
          <div className="service-menu">
            {services.map((service, index) => {
              const isActive = index === activeIndex;
              return (
                <button
                  type="button"
                  className={"service-menu-item" + (isActive ? " active" : "")}
                  key={service.title}
                  aria-pressed={isActive}
                  onClick={() => setActiveIndex(index)}
                >
                  <span className="service-menu-icon-wrap">
                    <img src={service.icon} alt="" className="service-icon" />
                  </span>
                  <span className="service-menu-text">
                    <span className="service-menu-title">
                      {service.title}
                      {service.badge && <span className="service-badge">{service.badge}</span>}
                    </span>
                    <span className="service-menu-subtitle">{service.subtitle}</span>
                  </span>
                </button>
              );
            })}
          </div>

          <div className="service-detail" key={activeIndex}>
            <div className="service-detail-header">
              <span className="service-detail-icon-wrap">
                <img src={activeService.icon} alt="" className="service-icon" />
              </span>
              <div>
                <h3 className="service-detail-title">
                  {activeService.title}
                  {activeService.badge && <span className="service-badge">{activeService.badge}</span>}
                </h3>
                <p className="service-detail-subtitle">{activeService.subtitle}</p>
              </div>
            </div>
            <p className="service-accordion-intro">{activeService.intro}</p>
            {activeService.sections.map((section) => (
              <div className="service-accordion-section" key={section.heading}>
                <h3>{section.heading}</h3>
                {section.text && <p>{section.text}</p>}
                {section.items && (
                  <ul>
                    {section.items.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicePanel;
